// Module description

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

// State schema
const state = {
  events: [],
  currentCity: {},
  currentMapCenter: {},
  currentMerchant: {},
  currentPlaceID: {}
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/app/module.js